import { render } from "./modalidad.vue?vue&type=template&id=c1463d54&scoped=true"
import script from "./modalidad.vue?vue&type=script&lang=js"
export * from "./modalidad.vue?vue&type=script&lang=js"

import "./modalidad.vue?vue&type=style&index=0&id=c1463d54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1463d54"]])

export default __exports__